<template>
  <div>
    <PublicHeader v-bind="$props" />
    <div class="p-lg-7 min-vh-50" style="margin: 6rem auto">
      <div class="has-text-left">
        <h1 class="title is-2 mb-6">{{ leagueName || organizationName }}</h1>

        <div v-html="homeTextHTML" />
      </div>
    </div>
    <PublicFooter v-bind="$props" />
  </div>
</template>

<script>
import PublicHeader from "@/components/PublicHeader.vue";
import PublicFooter from "@/components/PublicFooter.vue";

export default {
  metaInfo() {
    return {
      title: `${this.leagueName} | Diamond Scheduler`,
      ...this.metaContent,
    };
  },
  components: { PublicFooter, PublicHeader },
  props: [
    "seasonId",
    "domain",
    "organizationName",
    "leagueName",
    "homeTextHTML",
    "logoUrl",
    "metaContent",
    "showTeamsPage",
    "showStandingsPage",
    "showSchedulesPage",
    "showScoresPage",
    "showRostersPage",
  ],
};
</script>
